export enum InvestorBankAccountsActionTypes {
  REQUEST_INVESTOR_BANK_ACCOUNTS = '@@investor-bank-accounts/REQUEST_INVESTOR_BANK_ACCOUNTS',
  REQUEST_INVESTOR_BANK_ACCOUNTS_SUCCESS = '@@investor-bank-accounts/REQUEST_INVESTOR_BANK_ACCOUNTS_SUCCESS',
  REQUEST_INVESTOR_BANK_ACCOUNTS_FAILED = '@@investor-bank-accounts/REQUEST_INVESTOR_BANK_ACCOUNTS_FAILED',
  SET_SORT_PARAMS = '@@investor-bank-accounts/SET_SORT_PARAMS',
}
